<template>
    <v-layout class="form-layout" align-center column>
        <span class="reset-title mt-10">{{title}}</span>
        <span class="sub-title my-3">{{subTitle}}</span>
      <v-form class="ma-3 form" @submit.prevent>
          <v-text-field
                        data-qa="current-password-field"
                        v-if="includedFields.currentPassword"
                        class="vTextField my-2 confirmation-text-field"
                        :append-icon="showCurrentPasswordIcon ? 'icon-Hide1' :'icon-Eye-open'"
                        v-model="currentPassword"
                        tabindex="1"
                        :type="showCurrentPasswordIcon ? 'text' : 'password'"
                        :error-messages="currentPasswordErrorText"
                        :label="$t('common.login.passwords.current_password')"
                        @click:append="showCurrentPasswordIcon = !showCurrentPasswordIcon"
                        @blur="onCurrentPasswordBlur"
                        @keyup.enter.prevent
                        autocomplete="off"
                        required
                        outlined
          ></v-text-field>
          <v-text-field
                        data-qa="new-password-field"
                        :append-icon="showPasswordIcon ? 'icon-Hide1' :'icon-Eye-open'"
                        class="vTextField my-2 new-password-text-field"
                        v-model="newPassword"
                        :type="showPasswordIcon ? 'text' : 'password'"
                        :error-messages="newPasswordErrorText"
                        :label="$t('common.login.passwords.new_password')"
                        @click:append="showPasswordIcon = !showPasswordIcon"
                        :style="{ borderColor: branding.secondary_color, color: branding.text_color}"
                        tabindex="1"
                        @blur="changeNewPasswordFocusedState"
                        @focus="changeNewPasswordFocusedState"
                        @mouseover="newPasswordOnMouseOver"
                        autocomplete="off"
                        @keyup.enter="onClick"
                        required
                        outlined
          ></v-text-field>
          <v-layout v-if="firstFocused" column class="py-3 conditions">
            <div v-for="condition in passwordConditions" :key="condition.id" >
              <v-icon :class="getConditionIconClass(condition)">
                {{ getConditionIcon(condition) }}
              </v-icon>
              <span class="conditions-span" :class="getConditionSpanClass(condition)">
                {{condition.label}}
              </span>
            </div>
          </v-layout>
          <v-text-field
                        data-qa="confirmation-password-field"
                        :type="showConfirmationPasswordIcon ? 'text' : 'password'"
                        v-if="includedFields.confirmationPassword"
                        class="vTextField my-2"
                        :append-icon="showConfirmationPasswordIcon ? 'icon-Hide1' :'icon-Eye-open'"
                        v-model="confirmationPassword"
                        :error-messages="confirmationPasswordError"
                        :label="$t('common.login.passwords.confirmation_password')"
                        @click:append="showConfirmationPasswordIcon = !showConfirmationPasswordIcon"
                        tabindex="1"
                        @blur="changeConfirmationPasswordFocusedState"
                        @focus="changeConfirmationPasswordFocusedState"
                        autocomplete="off"
                        @keyup.enter="onClick"
                        @paste.prevent
                        required
                        outlined
          ></v-text-field>
          <VcButton
                    data-qa="change-password-button"
                    class="reset-password-button mt-6 mb-4"
                    :label="resetButtonText ? resetButtonText : this.$t('common.login.passwords.reset_password')"
                    @click="onClick"
                    :loading="btnLoading"
                    :disabled="!enableResetButton"></VcButton>
      </v-form>
      <a v-if="showLink" class="link ml-2" @click="onLinkClick">{{linkText}}</a>
    </v-layout>
</template>

<script>
import {mapGetters} from "vuex";
import {httpService} from "@/modules/common/services";
export default {
  name: "ResetPassword",
  props:{
    includedFields:{
      type:Object,
      required:true
    },
    linkText:{
      type: String,
      default: ''
    },
    showLink:{
      type: Boolean,
      default: true
    },
    resetButtonText:{
      type: String,
    },
    title:{
      type: String,
      required: true
    },
    subTitle:{
      type: String,
      required: true
    },
    btnLoading:{
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      currentPasswordErrorText:'',
      showCurrentPasswordIcon:false,
      showPasswordIcon:false,
      showConfirmationPasswordIcon:false,
      currentPassword: '',
      newPassword: '',
      confirmationPassword:'',
      newPasswordFocused: false,
      confirmationPasswordFocused: false,
      firstFocused: false,
      confirmationPasswordErrorText: '',
      lastCheckedCurrentPassword:'',
      passwordConditions:[
        {
          id: 'eightChars',
          label: this.$t('common.login.passwords.password_conditions.eight_characters'),
          isValid: this.eightChars,
        },{
          id: 'oneLower',
          label: this.$t('common.login.passwords.password_conditions.one_lowercase'),
          isValid: this.oneLower,
        },{
          id: 'oneUpper',
          label: this.$t('common.login.passwords.password_conditions.one_uppercase'),
          isValid: this.oneUpper,
        },{
          id: 'oneNumber',
          label: this.$t('common.login.passwords.password_conditions.one_number'),
          isValid: this.oneNumber,
        },
      ]
    }
  },
  computed:{
    ...mapGetters({isMobileApp: 'isMobileApp', branding: "brandModule/branding"}),
    enableResetButton(){
      let shouldEnableResetButton = this.newPassword && this.isPasswordCriteriaFull
      if(this.includedFields.currentPassword)
        shouldEnableResetButton = shouldEnableResetButton && this.currentPassword
      return shouldEnableResetButton
    },
    isPasswordCriteriaFull(){
      return this.eightChars() && this.oneLower() && this.oneUpper() && this.oneNumber()
    },
    newPasswordErrorText(){
      return ( !this.newPasswordFocused && !this.isPasswordCriteriaFull && this.newPassword !== '') ? this.$t('common.login.passwords.errors.password_missing_criteria') : ''
    },
    confirmationPasswordError(){
      if(this.enableResetButton && !this.newPasswordFocused && !this.confirmationPasswordFocused && this.newPassword !== this.confirmationPassword)
        return this.confirmationPasswordErrorText;
      return '';
    },
  },
  methods: {
    onClick() {
      if(this.enableResetButton && this.newPassword){
        this.confirmationPasswordFocused = false
        this.$emit('click', {
          password: this.newPassword,
          confirmationPassword: this.confirmationPassword,
          currentPassword: this.currentPassword
        })
      }
    },
    onLinkClick(){
      this.$emit('linkClick')
    },
    getConditionIcon(condition){
      if(condition.isValid()){
        return 'icon-circle-check'
      }
      else{
        if(!this.newPasswordFocused && this.newPassword !== '')
          return 'icon-warning'
        else
          return 'icon-circle-check'
      }
    },
    getConditionSpanClass(condition){
      if(condition.isValid()){
        return 'regular-condition'
      }
      else{
        if(!this.newPasswordFocused && this.newPassword !== '')
          return 'invalid-condition'
        else
          return 'regular-condition'
      }
    },
    getConditionIconClass(condition){
      if(condition.isValid()){
        return 'valid-condition'
      }
      else{
        if(!this.newPasswordFocused && this.newPassword !== '')
          return 'invalid-condition'
        else
          return 'regular-condition'
      }
    },
    eightChars() {
      return this.newPassword && this.newPassword.length >= 8
    },
    oneUpper() {
      return this.newPassword && this.newPassword.match(/[A-Z]+/)
    },
    oneLower() {
      return this.newPassword && this.newPassword.match(/[a-z]+/)
    },
    oneNumber() {
      return this.newPassword && this.newPassword.match(/[0-9]+/)
    },
    changeNewPasswordFocusedState(){
      this.newPasswordFocused = !this.newPasswordFocused
      this.confirmationPasswordErrorText = ''
    },
    newPasswordOnMouseOver(){
      this.firstFocused = true
    },
    changeConfirmationPasswordFocusedState(){
      this.confirmationPasswordFocused = !this.confirmationPasswordFocused
       this.confirmationPasswordErrorText = ''
    },
    onCurrentPasswordBlur(){
      if(this.currentPassword && this.currentPassword !== this.lastCheckedCurrentPassword){
        this.$emit('currentPasswordBlur', this.currentPassword)
        this.lastCheckedCurrentPassword = this.currentPassword
      }
    },
    setCurrentPasswordError(errorText){
      this.currentPasswordErrorText = errorText
    },
    setConfirmationPasswordError(errorText){
      this.confirmationPasswordErrorText = errorText
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.form-layout{
  margin: 0 auto;
  background: $white-color-1;
  flex: 0 0 auto;
  width: 100%;
  @include md-and-up{
    width: 611px;
    min-height: 550px;
    box-shadow: 0px 4px 18px rgba(145, 152, 160, 0.25);
    border-radius: 6px;
  }

  .form {
    width: 68%;
    @include sm-and-down{
      width: 90%;
      height: 70%;
      max-height: 70%;
    }
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
  }

  .link {
    color: $blue-color-4;
    font-family: var(--primary-font-family);
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
    height: 15px;
    text-align: center;
    margin-bottom: 30px;
  }

  ::v-deep.vTextField.v-text-field {
    max-height: 50px;
    width: 100%;
    border: none;

    .v-input__slot {
      .v-input__append-inner .v-icon.v-icon{
          font-size:16px;
        }

      fieldset{
        border: none;
      }
    }

    &.v-input--is-focused label{
      margin-top: 8px;
    }

    &.error--text {
      .v-text-field__details{
        padding: 0px 0px 10px 0px !important;
        margin-bottom: 10px;
        font-size: 6px;
      }

      + div.layout.column.conditions{
        margin-top:20px;
      }
    }
    & label.error--text{
      color:#616161 !important;
    }

    &.v-input--is-label-active, &.v-input--is-focused {
      label {
        font-family: var(--primary-font-family);
        font-style: normal;
        font-weight: normal;
        margin-top:8px;
        font-size: 14px;
        color: #616161 !important;
        line-height: 16px;
        transform: translateY(-18px) scale(0.85);
      }

      input{
        margin-top:14px;
        font-family: var(--primary-font-family);
        font-style: normal;
      }

      input[type="text"] {
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
      }
      input[type="password"] {
        font-weight: 700;
        font-size: 25px;
        line-height: 25px;
        color: rgba(117, 117, 117, 1);
        letter-spacing: 2px;
      }
    }

    &:not(.v-text-field--outlined) {
      .v-text-field__slot {
        transition: margin-bottom 0.1s;
      }

      &.v-input--is-label-active, &.v-input--is-focused {
        .v-text-field__slot {
          margin-bottom: 0;
        }

        .v-input__slot {
          padding-top: 20px;
        }
      }
    }

    .v-input__slot {
      height: 52px;
      border-radius: 6px;
      background-color: #fff !important;
      position: relative !important;
      border: solid 1px rgba(224, 224, 224, 1);
      transition: border-color 0.1s !important;

      &:hover {
        border-color: rgba(117, 117, 117, 1);
      }

      &:focus-within{
      border-color: var(--v-secondary-base);
      box-shadow: 0 0 0 3px var(--v-secondary-lighten1);
      transition: box-shadow 0.1s !important;
    }

      &:before, &:after {
        display: none;
      }

      .v-input__append-inner div button{
          color: #616161 !important;
      }
    }
    .v-text-field__prefix {
      color: $color_dark_sec_text !important;
    }

    &.error--text .v-input__slot{
        border: 0.5px solid red;
        box-shadow: none;
    }

    &.v-input--is-disabled .v-input__slot{
        background-color: rgba(0, 0, 0, 0.03) !important;
    }
  }

  ::v-deep.confirmation-text-field.v-text-field.error--text + div.new-password-text-field{
      margin-top:24px!important;
  }

  .conditions-span{
    font-family: var(--primary-font-family);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 28px;
    max-width: 164px;
    max-height: 20px;
  }

  .reset-title {
    font-family: var(--primary-font-family);
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    max-width: 50%;
    @include sm-and-down{
      max-width: 80%;
    }
  }

  .sub-title {
    font-family: var(--primary-font-family);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #616161;
    max-width: 50%;
    @include sm-and-down{
      max-width: 80%;
    }
  }

  .reset-password-button {
    width: 100%;
    height: auto;
    font-family: var(--primary-font-family);
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 24px;
    text-align: center;

    &.theme--light.v-btn.v-btn--disabled {
      background: rgba(237, 237, 237, 1) !important;
      color: #999999!important;
    }

    ::v-deep.v-btn__content {
      flex-flow: row wrap;
      width: 100%;
      white-space: break-spaces;
    }
  }
}

.invalid-condition{
  color: $red-color-5;
  font-size: 16px;
}
.regular-condition {
  color: rgba(117, 117, 117, 1);
  font-size: 18px;
}
.valid-condition{
  color: $green-color-2;
  font-size: 18px;
}
.regular_link {
  display:flex;
}
.logo {
  height: 41px;
  margin-top: 18px;
  cursor:pointer;
}

</style>
